<template lang="pug">
    v-container( fluid pa-0 )
        v-toolbar(dark='' color='primary')
            v-toolbar-title.white--text General
            v-spacer
            div(v-if="!isAuthorized")
                v-btn(color="success" @click="authorizeFiniquito" v-if="$can('AUTHORIZE_VALID_FINIQUITO')")
                    | Autorizar
                v-btn(:color="colors.danger" @click="rejectFiniquito" v-if="$can('AUTHORIZE_VALID_FINIQUITO')")
                    | Rechazar
        v-layout(row wrap)
            v-flex.pa2(md12)
                crud-form(
                    :editable="!isAuthorized"
                    :readOnly="isAuthorized"
                    :fields="generalFields" 
                    noButtons 
                    @submitForm="generalFormSubmit" 
                    @editable="editableFormController"
                    ref="generalForm"
                )
        v-toolbar(dark='' color='primary')
            v-toolbar-title.white--text Indemnización Contractual y Feriado Proporcional
        v-layout(row wrap)
            v-flex.pa2(md12)
                crud-form.pl-5.pt-3(
                    :readOnly="statusReadOnly"
                    :fields="contractualFields" 
                    noButtons 
                    @submitForm="indemnizationFormSubmit" 
                    ref="indemnizationContractualForm"
                    formTitle="Indemnización contractual"
                    noPadding
                )
                crud-form.pl-5.pt-3(
                    :readOnly="statusReadOnly"
                    :fields="proportionalFields" 
                    noButtons 
                    @submitForm="ProportionalHolidaySubmit" 
                    ref="ProportionalHolidayForm"
                    formTitle="Feriado Proporcional"
                    noPadding
                )        
                v-btn(block color="success" v-if="!statusReadOnly" @click="updateFiniquito") Guardar Edición
        v-layout(row wrap)
            v-flex(md12)
                v-toolbar.mt-5(dark='' color='primary')
                    v-toolbar-title.white--text Detalle
                    v-btn(flat='' icon='' color='default' @click="showDetailForm")
                        v-icon arrow_drop_down
                    v-spacer
                    v-btn(color="success")
                        | EXCEL
                    v-btn(:color="colors.danger")
                        | PDF
            v-flex(md12 v-show="showDetail" )
                v-card()
                    finiquito-detail.mt-2.mb-2(:finiquitoData="finiquitoData" )

</template>

<script>
/* components */
import { CrudForm } from '@/components/reusable_components/'
import FiniquitoDetail from './FiniquitoDetail'
/* generalFields */
import generalFields from './generalFields'
import fieldsIndemnizationContractual from '../create/finiquito/fieldsIndemnizationContractual'
import fieldsProportionalHoliday from '../create/finiquito/fieldsProportionalHoliday'
/* services */
import FiniquitoService from '@/services/api/finiquito'
import HrCausalService from '@/services/api/hrCausal'
/* vuex */
import { mapActions, mapState } from 'vuex'
/* mixins */
import CurrencyUtils from '@/mixins/reusable_mixins/CurrencyUtils'
export default {
    name: 'show-edit-finiquito',
    // props: {},
    data: function() {
        return {
            generalFields: generalFields,
            contractualFields: fieldsIndemnizationContractual,
            proportionalFields: fieldsProportionalHoliday,
            employeeId: null,
            finiquitoId: null,
            finiquito: {},
            readOnly: true,
            generalData: {},
            generalValidated: false,
            proportionalData: {},
            proportionalValidated: false,
            indemnizationContractualData: {},
            indemnizationContractualValidated: false,
            isAuthorized: false,
            showDetail: false,
        }
    },
    computed: {
        statusReadOnly: {
            get: function() {
                return this.readOnly
            },
            set: function(value) {
                this.readOnly = value
            },
        },
        finiquitoData() {
            let detail = this.getDetail()
            return detail
        },
        ...mapState('SnackbarModalModule', {
            responseConfirm: 'responseConfirm',
        }),
    },
    methods: {
        // -- UI Modification
        // -- Data fetching
        async fetchFiniquito() {
            return await FiniquitoService.fetchById(this.finiquitoId)
        },
        /**
         * fetchCausales
         * @returns array Causales despido
         */
        async fetchCausales() {
            return await HrCausalService.fetchAll()
        },

        // -- Data handling and transformations
        setEmployeeId(finiquito) {
            this.employeeId = finiquito.hr_employee_id
        },
        // -- Validations and Error handling
        // -- Other functions
        setFiniquitoId() {
            this.finiquitoId = this.$route.params.id
        },
        setFiniquito(finiquito) {
            this.finiquito = finiquito
        },
        async setAllForms() {
            let finiquito = await this.fetchFiniquito()
            if (finiquito) {
                this.setGeneralForm(finiquito)
                this.setContractualForm(finiquito)
                this.setProportionalForm(finiquito)
                this.setEmployeeId(finiquito)
                this.setFiniquito(finiquito)
                this.setAuthorizeFiniquito(finiquito)
            } else {
                //TODO: THROW MESSAGE FINIQUITO DONT FOUND
            }
        },
        /**
         *
         */
        setGeneralForm(finiquito) {
            let setFields = [...this.generalFields]
            setFields[0].value = this.setFullName(finiquito)
            setFields[1].value = finiquito.init_date
            setFields[2].value = finiquito.end_date
            setFields[3].value = finiquito.notice_date
            setFields[4].value = finiquito.payment_date
            setFields[5].value = finiquito.hr_causal_id
            this.generalFields = [...setFields]
        },
        setFullName(finiquito) {
            const name = finiquito.g_user.hr_employee.names
            const last_name1 = finiquito.g_user.hr_employee.last_name1
            const last_name2 = finiquito.g_user.hr_employee.last_name2
            const fullName = `${name} ${last_name1} ${last_name2}`
            //
            return fullName
        },
        /**
         *
         */
        setProportionalForm(finiquito) {
            let setFields = [...this.proportionalFields]
            setFields[0].value = finiquito.freedays_proportional_days
            setFields[1].value = finiquito.freedays_proportional_festive_days
            this.proportionalFields = [...setFields]
        },
        /**
         *
         */
        setContractualForm(finiquito) {
            let setFields = [...this.contractualFields]
            setFields[0].value = parseInt(finiquito.agreed_compensation_days)
            this.contractualFields = [...setFields]
        },
        async setCausales() {
            let causales = await this.fetchCausales()
            let setFields = [...this.generalFields]
            setFields[5].options.data = causales
            this.generalFields = [...setFields]
        },
        /**
         * this function receive
         * status of first form that control
         * the switch editable, and it's copied
         * to the other 2 forms.
         */
        editableFormController(status) {
            this.statusReadOnly = !status.editable
        },
        indemnizationFormSubmit(event) {
            ;(this.indemnizationContractualData = { ...event }),
                (this.indemnizationContractualValidated = true)
        },
        ProportionalHolidaySubmit(event) {
            console.log('proportionalHoliday', event)
            this.proportionalData = { ...event }
            this.proportionalValidated = true
        },
        generalFormSubmit(event) {
            ;(this.generalData = { ...event }),
                (this.generalData.hr_employee_id = this.employeeId)
            this.generalValidated = true
        },
        async updateFiniquito() {
            this.backInitialStatusNotValidated()
            this.fireValidateAllForms()
            if (this.checkValidateAllForms()) {
                let response = await FiniquitoService.updateFiniquito(
                    this.getFiniquitoId(),
                    this.getSubmitData()
                )
                const finiquitoId = this.finiquitoId
                const route = `/finiquitos/${finiquitoId}`
                this.snackResponseSubmit(response, 'Actualizado', route)
            }
        },
        /**
         * fireValidateAllForms
         * Esta función dispara todas las
         * validaciones que son necesarias para cada
         * form
         */
        fireValidateAllForms() {
            this.fireValidateGeneralForm()
            this.fireValidateIndemnizationForm()
            this.firedValidateProportionalForm()
        },
        fireValidateGeneralForm() {
            this.$refs.generalForm.submitForm()
        },
        fireValidateIndemnizationForm() {
            this.$refs.indemnizationContractualForm.submitForm()
        },
        firedValidateProportionalForm() {
            this.$refs.ProportionalHolidayForm.submitForm()
        },
        checkValidateAllForms() {
            if (!this.generalValidated) return false
            if (!this.indemnizationContractualValidated) return false
            if (!this.proportionalValidated) return false
            return true
        },
        backInitialStatusNotValidated() {
            this.generalValidated = false
            this.indemnizationContractualValidated = false
            this.proportionalValidated = false
        },
        /**
         * this method join in one
         * object data for submit.
         */
        getSubmitData() {
            let submit = {
                ...this.generalData,
                ...this.indemnizationContractualData,
                ...this.proportionalData,
            }
            return submit
        },
        getFiniquitoId() {
            return this.finiquitoId
        },
        /**
         *
         */
        snackResponseSubmit(response, actionDone, redirectRoute) {
            console.log(response, 'responseSubmit')
            if (response.status === 'success' || response.status === 200) {
                const msg = `Finiquito ${actionDone} exitosamente`
                this.successMessage(msg)
                this.redirectTo(redirectRoute)
                //this.redirectTo(`/finiquitos/${finiquitoId}`)
            } else this.errorMessage(response)
        },
        /**
         *
         */
        successMessage(message) {
            this.resetSnackbarState()
            this.initSnackbar(
                this.fillSnack('success', 'Éxito', message, false, 5000)
            )
        },
        /**
         *
         */
        errorMessage(response) {
            this.resetSnackbarState()
            if (response.error)
                this.initSnackbar(
                    this.fillSnack(
                        'error',
                        'Error',
                        response.error,
                        false,
                        5000
                    )
                )
            else
                this.initSnackbar(
                    this.fillSnack(
                        'error',
                        'Error',
                        'Ha ocurrido un error al enviar los datos al servidor',
                        false,
                        5000
                    )
                )
        },
        /**
         *
         */
        redirectTo(route) {
            this.$router.push(route)
        },
        setAuthorizeFiniquito(finiquito) {
            this.isAuthorized =
                finiquito.hr_finiquito_status.status === 'Autorizado'
                    ? true
                    : false
        },
        rejectFiniquito() {
            this.resetSnackbarState()
            this.setMessageConfirmSnack('Rechazar')
            this.initSnackbar(
                this.fillSnack(
                    'warning',
                    'Rechazar Finiquito',
                    '¿Estas seguro de querer Rechazar el finiquito seleccionado?'
                )
            )
        },
        authorizeFiniquito() {
            this.resetSnackbarState()
            this.setMessageConfirmSnack('Autorizar')
            this.initSnackbar(
                this.fillSnack(
                    'info',
                    'Autorizar Finiquito',
                    '¿Estas seguro de querer Autorizar el finiquito seleccionado?'
                )
            )
        },
        async submitAuthorizeFiniquito() {
            const id = this.finiquitoId
            const route =
                process.env.VUE_APP_API_ROUTE + `/hr_finiquito/${id}/authorize`
            let resp = await FiniquitoService.decideAction(route)
            const redirectRoute = '/finiquitos'
            this.snackResponseSubmit(resp, 'Autorizado', redirectRoute)
        },
        async submitRejectFiniquito() {
            const id = this.finiquitoId
            const route =
                process.env.VUE_APP_API_ROUTE + `/hr_finiquito/${id}/reject`
            let resp = await FiniquitoService.decideAction(route)
            const redirectRoute = '/finiquitos'
            this.snackResponseSubmit(resp, 'Rechazado', redirectRoute)
        },
        showDetailForm() {
            this.showDetail = !this.showDetail
        },
        getDetail() {
            let detail = [
                {
                    type: 'Remuneraciones pendientes',
                    amount: this.formatCurrency(
                        this.finiquito.pending_remunerations
                    ),
                },
                {
                    type: 'Indemnización sustitutiva',
                    amount: this.formatCurrency(
                        this.finiquito.substituve_compensation
                    ),
                },
                {
                    type: 'Indemnización Legal por años de servicio',
                    amount: this.formatCurrency(
                        this.finiquito.legal_compensation_for_year_of_service
                    ),
                },
                {
                    type: 'Indemnización contractual',
                    amount: this.formatCurrency(
                        this.finiquito.agreed_compensation
                    ),
                },
                {
                    type: 'Feriado proporcional',
                    amount: this.formatCurrency(
                        this.finiquito.proportional_freedays
                    ),
                },
                {
                    type: 'Total finiquito',
                    amount: this.formatCurrency(this.finiquito.total),
                },
            ]
            return detail
        },
        // -- Vuex mappings
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),
    },
    watch: {
        responseConfirm(val) {
            switch (val) {
                case 'Autorizar':
                    this.submitAuthorizeFiniquito()
                    break
                case 'Rechazar':
                    this.submitRejectFiniquito()
                    break
                default:
                    break
            }
        },
    },
    components: {
        'crud-form': CrudForm,
        'finiquito-detail': FiniquitoDetail,
    },
    mixins: [CurrencyUtils],
    // filters: {},
    // -- Lifecycle Methods
    beforeMount() {
        this.setTitleTopBar('Detalle finiquito')
        this.setCausales()
        this.setFiniquitoId()
        this.setAllForms()
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (
                !(
                    ctx.$can('VIEW_DETAIL_FINIQUITO') &&
                    ctx.$can('EDIT_FINIQUITO')
                )
            )
                ctx.$router.push('/')
        })
    },
    // -- End Lifecycle Methods
}
</script>

<style lang="scss">
</style>